import api from './axios';

/**
 * Mutual-aid claims (spec §8.4).
 *
 * No amount is sent on file: the server derives it from the benefit catalog
 * (lump sum, or units × per-diem rate), so the SPA renders the ceiling from
 * `getBenefitCatalog()` rather than hardcoding the six figures.
 */
export const getBenefitCatalog = ()               => api.get('/v1/benefit-catalog');

/**
 * Adjusts one benefit's ceiling. These are the numbers every claim decision
 * is bounded by, so they are admin rows rather than a PHP enum (Rule 76).
 */
export const updateBenefit     = (benefitKey, payload) =>
  api.put(`/v1/admin/benefit-catalog/${benefitKey}`, payload);
export const listClaims        = (params = {})    => api.get('/v1/claims', { params });
export const fileClaim         = (payload)        => api.post('/v1/claims', payload);
export const appealClaim       = (claimId, payload) => api.post(`/v1/claims/${claimId}/appeal`, payload);

/** decision: 'approve' | 'deny' | 'disburse'. */
export const decideClaim       = (claimId, payload) => api.post(`/v1/claims/${claimId}/decide`, payload);

/**
 * Attaches a supporting document. Multipart — do NOT set Content-Type by hand;
 * the browser has to add the multipart boundary itself.
 */
export const attachClaimDocument = (claimId, { file, documentLabel }) => {
  const form = new FormData();
  form.append('document', file);
  if (documentLabel) form.append('document_label', documentLabel);

  return api.post(`/v1/claims/${claimId}/attachments`, form, {
    headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
  });
};

/** Document metadata only — the S3 key never reaches the browser. */
export const listClaimAttachments = (claimId) => api.get(`/v1/claims/${claimId}/attachments`);

/**
 * A short-lived link to one document. Minted when the reviewer opens it and
 * expiring in ten minutes — it is a bearer credential for a medical record, so
 * it is never cached alongside the row.
 */
export const getClaimAttachmentLink = (claimId, attachmentId) =>
  api.get(`/v1/claims/${claimId}/attachments/${attachmentId}`);

export const createClaimsExport = (filters = {}) => api.post('/v1/claim-exports', filters, {
  headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
});

export const getClaimsExport = (id) => api.get(`/v1/claim-exports/${id}`);
